<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="false"
          prop="id"
          label="id"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="userName"
          label="用户名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="updateDate"
          label="操作时间"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.updateDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          label="操作内容"
          align="left"
        ></el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/pagination";
import { formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      multipleSelection: [], //多选的数据
      sortnum: 0,
      memberData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime1(time);
    },
  },
  components: {
    Pagination,
  },
  computed: {
    ...mapGetters(["search", "memberSearch"]),
  },
  created() {},
  mounted() {
    this.getOperationRecord();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    handleChangePageAndLimit() {
      this.memberData.page = 1;
      this.memberData.limit = 20;
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取会员列表数据
    getOperationRecord() {
      const para = Object.assign({}, this.memberData);
      console.log(para);
      getOperationRecord(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.operationRecords;
      });
    },
    // 上下分页
    handleCurrentChange(val) {
      this.memberData.page = val;
      this.getOperationRecord();
    },
    changePageAndLimit() {
      this.memberData.page = 1;
      this.memberData.limit = 20;
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.memberData.limit = val;
      this.getOperationRecord();
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


